import { useState } from "react";
import { feedItems } from "@/mocks/leakHome";

const tabs = ["全部", "瓜田速报", "私信倾诉", "我想说", "内幕速递"];

export default function TimelineFeed() {
  const [tab, setTab] = useState("全部");
  const list = tab === "全部" ? feedItems : feedItems.filter((f) => f.tag === tab);

  return (
    <section id="feed" className="w-full bg-[#faf8f4] py-10 md:py-14">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <div>
            <p className="text-xs font-bold tracking-widest text-red-500">LIVE FEED</p>
            <h2 className="mt-1 flex items-center gap-2 text-2xl font-black text-stone-800 md:text-3xl">
              最新上墙
              <span className="flex items-center gap-1 rounded-full bg-red-100 px-2.5 py-1 text-xs font-bold text-red-600">
                <i className="ri-dv-line animate-pulse"></i>实时滚动
              </span>
            </h2>
            <p className="mt-2 text-sm text-stone-500">
              按时间一路往下刷，谁上墙了、谁被回话了，全在这条线里。
            </p>
          </div>

          <div className="flex flex-wrap gap-1 rounded-full bg-stone-100 p-1">
            {tabs.map((t) => (
              <button
                key={t}
                onClick={() => setTab(t)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition ${
                  tab === t ? "bg-red-600 text-white" : "text-stone-500 hover:text-stone-800"
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div className="relative mt-8">
          {/* 时间轴 */}
          <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-red-100 md:left-[23px]"></div>

          <div className="space-y-4">
            {list.map((item) => (
              <article
                key={item.id}
                className="relative flex gap-4 rounded-2xl border border-stone-100 bg-white p-3 shadow-sm transition hover:border-red-200 hover:shadow-md md:gap-5 md:p-4"
              >
                {/* 时间点 */}
                <div className="relative z-10 flex h-10 w-10 shrink-0 flex-col items-center justify-center rounded-full border-2 border-white bg-red-600 text-white shadow-md md:h-12 md:w-12">
                  <i className="ri-fire-line text-base md:text-lg"></i>
                </div>

                <div className="flex min-w-0 flex-1 flex-col gap-3 sm:flex-row">
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span
                        className={`rounded-md px-2 py-0.5 text-[11px] font-bold ${item.tagColor}`}
                      >
                        {item.tag}
                      </span>
                      {item.badge && (
                        <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold ${item.badgeStyle}`}>
                          {item.badge}
                        </span>
                      )}
                      <span className="text-xs text-stone-400">
                        <i className="ri-time-line mr-1 align-[-1px]"></i>
                        {item.time}
                      </span>
                    </div>
                    <h3 className="mt-2 text-base font-bold leading-snug text-stone-800 md:text-lg">
                      {item.title}
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-stone-500">{item.excerpt}</p>
                    <div className="mt-3 flex flex-wrap items-center gap-4 text-xs font-medium text-stone-400">
                      <span className="flex items-center gap-1">
                        <i className="ri-arrow-up-line"></i> {item.up.toLocaleString()}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-chat-3-line"></i> {item.reply.toLocaleString()} 条讨论
                      </span>
                      <a
                        href="#entry"
                        className="flex items-center gap-1 text-red-500 hover:text-red-600"
                      >
                        我也想说点 <i className="ri-arrow-right-line"></i>
                      </a>
                    </div>
                  </div>

                  <a
                    href="#feed"
                    className="group block h-36 w-full shrink-0 overflow-hidden rounded-xl sm:h-32 sm:w-44 md:h-36 md:w-56"
                  >
                    <img
                      src={item.cover}
                      alt={item.title}
                      title={`${item.title} - 52爆料投稿`}
                      className="h-full w-full object-cover object-center transition duration-500 group-hover:scale-105"
                    />
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>

        <div className="mt-6 flex items-center justify-center">
          <button className="flex items-center gap-2 rounded-full border border-red-200 bg-white px-6 py-2.5 text-sm font-semibold text-red-600 transition hover:bg-red-600 hover:text-white">
            <i className="ri-loader-4-line"></i> 加载更多上墙内容
          </button>
        </div>
      </div>
    </section>
  );
}